import type { FC, ReactNode } from "react";

export const LoadingSpinner: FC<{ text?: string }> = ({ text = "Yuklanmoqda..." }) => (
  <div className="loading">
    <div className="spinner" />
    <p>{text}</p>
  </div>
);

export const ErrorMessage: FC<{ message: string; onRetry?: () => void }> = ({ message, onRetry }) => (
  <div className="error-card">
    <p className="error-text">{message}</p>
    {onRetry && (
      <button onClick={onRetry} className="btn btn-secondary">
        Qayta urinish
      </button>
    )}
  </div>
);

export const Card: FC<{ children: ReactNode; className?: string }> = ({ children, className }) => (
  <div className={`card ${className ?? ""}`}>{children}</div>
);

export const Badge: FC<{ label: string; color?: string }> = ({ label, color }) => (
  <span className={`badge badge-${color ?? "default"}`}>{label}</span>
);
